<template>
    <div class="container">
        <content-header title="Ингибиторы протонной помпы в терапии кислотозависимых заболеваний"/>
        <div class="article-detail">
            <div class="comment_box">
                <div class="date">
                    <div class="value">06 СЕН 18</div>
                    <div class="arrow_date"></div>
                </div>
                <div class="comments_number">0 Комментарии</div>
            </div>
            <div class="article-detail__content">
                <div class="article-detail-top">
                    <div class="article-detail__title">
                        <h2>Ингибиторы протонной помпы в терапии кислотозависимых заболеваний</h2>
                    </div>
                    <a href="http://5-clinic.com/урсодезоксихолевая-кислота-в-гастро/" class="article-detail__image">
                        <img src="../../assets/images/staticPages/научная-статья-540x280.jpg" alt="научная-статья"
                             height="300" width="480"/>
                    </a>
                </div>

                <div class="article-detail__desc">
                    <div style="padding: 10px 0">
                        <strong>Научная статья наших
                            <router-link :to="{name: 'Наши Врачи'}"
                                         style="display: inline-block" class="link">врачей
                            </router-link>
                        </strong>
                        <div class="divider"></div>
                        <div class="flex">
                            <div class="box">
                                <img src="../../assets/images/staticPages/Шиндина-Татьяна-Сергеевна.png"
                                     alt="Шиндина-Татьяна-Сергеевна" height="100" width="150"/>
                                <div style="width: 220px; display: inline-block">
                                    <h3 style="font-size: 15px; font-weight: bold; color: #666">Шиндина Татьяна
                                        Сергеевна</h3>
                                    <p>Заведующая отделением
                                        Врач гастроэнтеролог
                                        Кандидат медицинских наук</p>
                                </div>
                            </div>
                            <div class="box">
                                <img src="../../assets/images/staticPages/Кропова-Ольга-Евгеньевна.png"
                                     alt="Кропова-Ольга-Евгеньевна" height="100" width="150"/>
                                <div style="width: 220px; display: inline-block">
                                    <h3 style="font-size: 15px; font-weight: bold; color: #666">Кропова Ольга
                                        Евгеньевна</h3>
                                    <p>Врач терапевт</p>
                                </div>
                            </div>
                        </div>
                        <div class="divider"></div>
                        <p>Авторы: Шиндина Т.С. 1 , Максимов М.Л. 2 , Кропова О.Е. 1 <br>
                            1 ФГБУ «Поликлиника No 5» УДП РФ, Москва<br>
                            2 КГМА — филиал ФГБОУ ДПО РМАНПО Минздрава России, Казань</p>
                        <p><strong>В 1824 г. У. Праут впервые определил, что кислотой, входящей в состав желудочного
                            сока, является соляная кислота (HCl). Спустя 100 лет была разработана шкала рН и впервые
                            проведена рН-метрия желудка и двенадцатиперстной кишки (ДПК) человека инструментальным
                            методом. С тех пор началось изучение HCl в целях диагностики и терапии заболеваний
                            ЖКТ.</strong></p>
                        <p>В настоящее время сформировалось и закрепилось такое стойкое понятие, как кислотозависимые
                            заболевания (КЗЗ). К группе КЗЗ относят язвенную болезнь (ЯБ) желудка и ДПК,
                            гастроэзофагеальную рефлюксную болезнь (ГЭРБ), панкреатит, некоторые виды функциональных
                            кишечных расстройств и др. С КЗЗ в своей практике встречаются врачи разного профиля:
                            терапевты, гастроэнтерологи, хирурги, кардиологи, пульмонологи, отоларингологи и др.<br>
                            Все это диктовало необходимость поиска препаратов, влияющих на уровень кислотной продукции.
                            Одними из первых стали применять холинолитики. Они снижают кислотную продукцию, тормозят
                            освобождение гастрина, уменьшают выработку пепсина, пролонгируют эффект антацидных средств,
                            усиливают буферные свойства пищи, уменьшают двигательную активность желудка и ДПК.
                            Наибольшее применение в практике получил пирензепин. Являясь селективным холинолитическим
                            препаратом, он избирательно блокирует преимущественно М1-холинорецепторы фундальных желез
                            слизистой оболочки желудка и не влияет в терапевтических дозах на холинорецепторы слюнных и
                            бронхиальных желез, сердечно-сосудистой системы, тканей глаза, гладких мышц, не вызывает
                            нежелательных реакций со стороны ЦНС.</p>
                        <p>С середины 1970-х гг. в клинической практике стали использовать Н2-блокаторы. Известно
                            несколько поколений этих лекарственных препаратов. После циметидина были последовательно
                            синтезированы ранитидин, фамотидин, а несколько позже – низатидин и роксатидин. Длительное
                            время «золотым стандартом» лечения КЗЗ считалось применение блокаторов Н2-гистаминовых
                            рецепторов. В свое время их появление ознаменовало собой революционный прорыв в лечении
                            патологии, связанной с гиперсекрецией HCl в желудке. Кроме блокады кислотообразования эти
                            препараты снижают базальную и стимулированную продукцию пепсина, увеличивают секрецию слизи
                            и бикарбонатов, синтез простагландинов и улучшают микроциркуляцию в слизистой желудка.
                            Доказано, что Н2-блокаторы тормозят дегрануляцию тучных клеток, снижают содержание гистамина
                            в периульцерозной зоне и увеличивают количество ДНК-синтезирующих эпителиальных клеток,
                            стимулируя тем самым репаративные процессы. Впрочем, есть факторы, ограничивающие применение
                            представителей этой фармакологической группы: недостаточный и непродолжительный (у некоторых
                            препаратов) антисекреторный эффект, торможение в основном базальной и ночной секреции,
                            резистентность к лечению у 5–20% больных, быстрое развитие толерантности и утрата
                            антисекреторного эффекта, высокая частота побочных эффектов при длительном применении
                            (антиандрогенный эффект, гепатотоксичность, тромбоцитопения, агранулоцитоз), феномен
                            «рикошета» в виде резкого усиления кислотопродукции после отмены препаратов.</p>
                        <p>Блокаторы Н2-гистаминовых рецепторов в большей (циметидин) или меньшей (ранитидин) степени
                            ингибируют CYP3A4, что приводит к развитию лекарственных взаимодействий с
                            препаратами-субстратами данного изофермента цитохрома Р450: блокаторами медленных кальциевых
                            каналов, статинами, противогрибковыми препаратами, пероральными контрацептивами, системными
                            глюкокортикостероидами и т. д. Для фамотидина влияние на CYP3A4 определяется как
                            минимальное. Препараты этой фармакологической группы способны влиять на биотрансформацию
                            непрямых антикоагулянтов, теофиллина, дифенина, β-адреноблокаторов и др. Нельзя применять
                            циметидин с диазепамом, хлордиазепоксидом (он удлиняет период их полувыведения),
                            цитостатиками и другими препаратами, вызывающими нейтропению [1].<br>
                            В 1979 г. компанией AstraZeneca (Великобритания/Швеция) был синтезирован первый в мире
                            ингибитор протонной помпы (ИПП) – омепразол, который с 1988 г. выходит на рынок под торговым
                            наименованием Лосек (в США и Канаде – Prilosec). Препарат используется при лечении ЯБ
                            желудка и ДПК, а также гастроэзофагеального рефлюкса. Причем ИПП в силу более выраженного
                            антисекреторного эффекта значительно потеснили антагонисты гистаминовых рецепторов. В
                            настоящее время ИПП занимают центральное место среди противоязвенных лекарственных средств.
                            Это связано, во-первых, с тем, что по антисекреторной активности (следовательно – и по
                            клинической эффективности) они значительно превосходят другие препараты. Во-вторых, ИПП
                            создают благоприятную среду для антихеликобактерного действия антибактериальных средств, в
                            связи с чем они включаются в качестве неотъемлемого компонента в большинство схем эрадикации
                            пилорического хеликобактера.<br>
                            Уникальность ИПП состоит в том, что они высокоселективно блокируют терминальную молекулу
                            кислотопродукции – H+/K+-АТФ-азу (рис. 1). По химической природе ИПП являются слабыми
                            основаниями, накапливаются в канальцах париетальных клеток, где в кислой среде (pH≤1)
                            происходит их преобразование в активную форму (сульфенамид) [2–5]. Сульфенамид ковалентно с
                            помощью дисульфидных связей соединяется с цистеиновыми группами протонной помпы, что
                            приводит к ингибированию H+/K+-АТФ-азы и угнетению секреции HCl. Скорость накопления ИПП в
                            канальцах париетальных клеток определяется показателем константы ионизации (диссоциации) –
                            рКа: чем больше константа, тем больше скорость трансформации ИПП в активную форму.
                            Кислотосупрессивный эффект ИПП по отношению как к базальной, так и к стимулированной
                            секреции длится в течение 24 ч и более. Примерно столько времени и требуется париетальной
                            клетке на синтез и интеграцию в мембрану новых молекул Н+/К+-АТФ-азы [6, 7]. Показано, что
                            однократный прием ИПП в средней терапевтической дозе приводит к угнетению желудочной
                            кислотопродукции на 80–98%, что на 48% больше по сравнению с антагонистами гистаминовых
                            Н2-рецепторов [5, 7]. Сравнительная характеристика кислотосупрессирующей активности ИПП и
                            антагонистов гистаминовых Н2-рецепторов представлена на рисунке 2.</p>
                        <p>Сравнительные исследования активности и эффективности ИПП и антагонистов гистаминовых
                            Н2-рецепторов проводятся при различных патологиях, например, у больных с ГЭРБ. Рассмотрены
                            исследования по лечению больных с ГЭРБ, в которые вошло 36 978 больных, были сделаны выводы,
                            что ИПП обладают лучшей лечебной эффективностью и быстрее купируют симптомы заболевания, чем
                            антагонисты Н2-рецепторов, которые в свою очередь лучше, чем плацебо.<br>
                            Обзор также показал, что нет никаких серьезных различий в эффективности среди имеющихся в
                            настоящее время ИПП (эзомепразол, лансопразол, омепразол, пантопразол, рабепразол).
                            Оценивались стандартные и низкие дозы различных групп ИПП. Низкие и стандартные дозы ИПП:
                            эзомепразол 20 мг, 40 мг; лансопразол 15 мг, 30 мг; пантопразол 20 мг, 40 мг. Все данные по
                            омепразолу и рабепразолу были с дозировкой 20 мг. Стандартные дозы блокаторов Н2-рецепторов
                            (все 2 р./сут): циметидин 400 мг, фамотидин 20 мг, низатидин 150 мг, ранитидин 150 мг.
                            Проводилась оценка числа пациентов, которых необходимо лечить, чтобы продемонстрировать это
                            преимущество, коэффициент риска и вероятности неудачи лечения в каждых группах. Полученные
                            результаты представлены в таблице 1. <br>
                            Данные анализа 21 клинического испытания [N. Chiba, R.H. Hunt, 1999], в которых проводилось
                            прямое сравнение ИПП с блокаторами Н2-рецепторов гистамина при обострении ЯБ ДПК, очень
                            показательны. Они подтвердили, что ИПП приводят к более быстрому заживлению язвы у большего
                            числа больных, чем антагонисты гистаминовых рецепторов. Обработка результатов исследований
                            позволила сделать некоторые важные заключения – например, вычислить величину абсолютного
                            снижения риска (разность доли больных с положительным результатом терапии в группе,
                            получавшей ИПП, и в группе, получавшей антагонисты гистаминовых рецепторов). При ЯБ желудка
                            применение ИПП также более эффективно: согласно метаанализу C.V. Howden et al. (1993),
                            которые сравнивали процент больных с зажившими язвами желудка в течение каждой недели
                            применения различных классов противоязвенных препаратов, омепразол как представитель ИПП
                            превосходил все остальные лекарственные средства. Применение ИПП характеризуется также более
                            скорым и полным купированием симптомов обострения заболевания [9].</p>
                        <p>За прошедшие годы синтезированы и используются в практической деятельности 6 разновидностей
                            ИПП: омепразол, лансопразол, рабепразол, эзомепразол, пантопразол и тенатопразол. Пять из
                            них применяются в России.<br>
                            Благодаря мощному антисекреторному эффекту значительно расширились возможности применения
                            ИПП в гастроэнтерологической практике. В частности, омепразол является препаратом выбора при
                            лечении и профилактике гастропатии, связанной с приемом нестероидных противовоспалительных
                            препаратов [11, 12]. Доказана клиническая эффективность ИПП при лечении ГЭРБ, в т. ч. и ее
                            осложненных форм [12–14].<br>
                            Применение ИПП при ЯБ значительно снизило частоту осложнений. Последними исследованиями
                            показано, что существенное снижение продукции HCl весьма уменьшает число повторных
                            кровотечений. ИПП являются эффективными препаратами при лечении острых и хронических
                            панкреатитов, т. к. блокада продукции HCl снимает стимуляцию внешнесекреторной функции
                            поджелудочной железы.<br>
                            Известно, что еще в 2000 г. в Маастрихтском соглашении Н2-блокаторы были исключены из схемы
                            эрадикационной терапии – предпочтение было отдано ИПП [15] благодаря многочисленным
                            позитивным воздействиям омепразола на Нelicobacter (Н.) pylori и гастродуоденальную зону.
                            При этом:<br>
                            – происходит защелачивание окружающей среды в желудке, не совместимое с жизнедеятельностью
                            Н. pylori;<br>
                            – сдвиг pH в щелочную сторону удлиняет период полужизни антител к Н. pylori и повышает их
                            концентрацию;<br>
                            – уменьшение объема желудочного сока приводит к повышению концентрации принимаемых
                            антибиотиков;<br>
                            – наблюдается угнетение уреазы Н. pylori и одной из ее АТФ-аз.<br>
                            Помимо этого важным качеством ИПП является их синергизм с антибактериальными средствами [16,
                            17].<br>
                            Продолжаются дискуссии и исследования лекарственного взаимодействия между различными ИПП и
                            антикоагулянтами и антиагрегантами. В 2013 г. проведено исследование, которое показало, что
                            профилактическое применение омепразола снижает риск развития желудочно-кишечного
                            кровотечения, и не показало очевидное – взаимодействие между клопидогрелом и омепразолом у
                            пациентов после установки стента сонной артерии [18]. 64 пациента были разделены на 2
                            группы. 1-я группа получала ИПП, 2-я – нет. Размеры рестенозов внутри стентов и тромбов по
                            данным транскраниальной допплерографии и УЗИ в послеоперационный период у пациентов на фоне
                            лечения ИПП и без достоверно не различались. Не были получены данные о влиянии омепразола на
                            клопидогрел. Также оценивался риск развития желудочного кровотечения, который на фоне приема
                            ИПП был достоверно ниже.<br>
                            Стоит отметить, что группа, принимавшая участие в данном исследовании, была малочисленной,
                            что заставляет продолжать исследования взаимодействия омепразола с другими лекарственными
                            препаратами.<br>
                            Исследование, проведенное японскими учеными в 2013 г., показало, что у пациентов с
                            рефлюкс-эзофагитом омепразол 20 мг более эффективен, чем рабепразол 10 мг, приводит к
                            стойкому купированию симптомов рефлюкс-эзофагита у лиц с фенотипом CYP2C19 PM [19].
                            Полученные данные нацеливают нас на индивидуальный подход к каждому пациенту.<br>
                            В статье С.Ю. Серебровой [20] приведен анализ сравнительной эффективности омепразола и
                            пантопразола у больных с ГЭРБ. Показано, что омепразол – эффективный и сравнительно
                            безопасный препарат для лечения заболеваний, ассоциированных с высокой интенсивностью
                            желудочной кислотопродукции. Пантопразол – ИПП, обладающий, по сравнению с омепразолом,
                            большей биодоступностью, но меньшей антисекреторной активностью и клинической эффективностью
                            при лечении ЯБ, рефлюкс-эзофагита I степени и при 8–недельной терапии рефлюкс-эзофагита II и
                            III степени по Савари–Миллеру (эквивалентны суточные дозы 20 мг омепразола и 40 мг
                            пантопразола). Из 2-х ИПП пантопразол однозначно может быть рекомендован лишь при
                            необходимости совместного применения с клопидогрелом или циталопрамом [20].<br>
                            В последние годы на российском фармацевтическом рынке появилось много препаратов из группы
                            ИПП – как оригинальных, так и дженериков, что создало определенные трудности в выборе
                            наиболее эффективного из них. Не утихают споры среди производителей ИПП о преимуществах тех
                            или иных препаратов. Однако многочисленные исследования сравнительной эффективности
                            различных групп ИПП показывают, что все эти препараты обладают выраженным антисекреторным
                            эффектом и позволяют поддерживать уровень интрагастрального рН больше 4 в среднем от 10 ч
                            (омепразол – Лосек) до 15,3 ч (эзомепразол (Нексиум) – данные исследования Miner). Это
                            считается достаточным для достижения высокой степени эпителизации эрозивных и язвенных
                            дефектов желудка и ДПК. Также было показано, что через 21 день от начала лечения достоверных
                            различий в эффективности рубцевания язв между омепразолом, рабепразолом, пантопразолом не
                            получено (р>0,1) [21].</p>
                        <p>Оригинальный препарат омепразола Лосек в России известен с начала 1990-х гг. В клинических
                            исследованиях, проведенных в России, были подтверждены высокие антиульцерогенные возможности
                            препарата как в пероральной форме, так и в форме для в/в введения [22, 23]. Начиная с 2005
                            г. Лосек поставляется в Россию в 2-х лекарственных формах: лиофилизата для приготовления
                            раствора для инфузий и в виде таблеток, изготовленных по технологии МАПС (англ. MUPS –
                            Multiple Unit Pellet System).<br>
                            МАПС обозначает запатентованную лекарственную форму омепразола. Каждая МАПС-таблетка (рис.
                            3) содержит около 1000 кислотоустойчивых микрокапсул омепразола магния, покрытых
                            дополнительной защитной оболочкой. Благодаря такой структуре омепразол не подвергается
                            агрессивному воздействию кислого содержимого желудка, а, попадая в щелочную среду ДПК,
                            распадается на омепразол, который в свою очередь без потерь очень быстро всасывается, и
                            магний, используемый организмом в качестве необходимого микроэлемента [24].</p>
                        <p>МАПС-форма обеспечивает лучшую доставку омепразола к париетальной клетке и, как следствие,
                            предсказуемый и воспроизводимый антисекреторный эффект. При эрозивно-язвенных поражениях
                            гастродуоденальной зоны таблетки МАПС обладают такой же эффективностью, как и омепразол в
                            капсуле. МАПС омепразол можно растворять в воде или соке, что обеспечивает удобство
                            применения. Возможность введения растворенных таблеток МАПС через назогастральный зонд
                            особенно актуальна для тяжелых больных – контингента реанимационных отделений, у которых
                            профилактика острых язв и эрозий является неотложной задачей [25]. Технология МАПС
                            обеспечивает предсказуемость в отношении попадания требуемой дозы омепразола в системный
                            кровоток и, соответственно, уверенность в том, что будет обеспечен требуемый эффект.<br>
                            На российском рынке имеется множество дженериков омепразола, которые по антисекреторной
                            активности часто проигрывают оригинальным препаратам. Это обусловлено качеством дженериков,
                            о чем свидетельствует наблюдаемая у отдельных препаратов высокая «первичная резистентность»
                            к первым стандартным дозам, которая уменьшается при удвоении разовой дозы [26].<br>
                            Таким образом, широкое распространение КЗЗ в популяции обусловливает высокую
                            востребованность ИПП в ежедневной клинической практике. Оригинальный препарат омепразола
                            Лосек (AstraZeneca) можно считать «главой семейства» омепразолов. Лекарственная форма Лосек
                            МАПС обеспечивает надежный антисекреторный эффект благодаря содержанию множества
                            кислотоустойчивых микрогранул омепразола, высвобождение активного вещества из которых
                            происходит лишь в щелочной среде ДПК. Снижение стоимости Лосека МАПС в 2013 г. позволило
                            обеспечить большую доступность оригинального высококачественного препарата для российских
                            пациентов [22].</p>
                        <img src="../../assets/images/staticPages/1459-1.jpg" alt="" height="317" width="296"/>
                        <div class="inv-divider"></div>
                        <img src="../../assets/images/staticPages/1459-2.jpg" alt="" height="251" width="297"/>
                        <div class="inv-divider"></div>
                        <img src="../../assets/images/staticPages/1459-3.jpg" alt="" height="221" width="298"/>
                        <div class="inv-divider"></div>
                        <img src="../../assets/images/staticPages/1459-4.jpg" alt="" height="313" width="607"/>
                        <div class="inv-divider"></div>
                        <p>Литература</p>
                        <p>1. Сереброва С.Ю. Антисекреторные препараты: равные среди равных? // iDoctor. 2014. № 2.
                            <br>2. Гастроэнтерология: национальное руководство / под ред. В.Т. Ивашкина, Т.Л. Лапиной.
                            М.: ГЭОТАР-Медиа, 2008. 706 с.
                            <br>3. Харкевич Д.А. Фармакология. М.: ГЭОТАР-Медиа, 2006. С. 350–364.
                            <br>4. Пасечников В.Д. Локализация, структура и функция париетальных клеток. Регуляция
                            кислотообразования. Клиническая фармакология ингибиторов протонной помпы. М., 2009. 51 с.
                            <br>5. Ткаченко Е.И., Успенский Ю.П., Каратеев А.Е., Бакулин И.Г., Пахомова И.Г.
                            Гастроэзофагеальная рефлюксная болезнь: патогенетические основы дифференцированной тактики
                            лечения // Экспериментальная и клиническая гастроэнтерология. 2009. № 2. C. 104–114.
                            <br>6. Лапина Т.Л. Фармакологические основы антисекреторной терапии // РМЖ. 2005. № 1. С.
                            23–27.
                            <br>7. Евсеев М.А. Антисекреторные препараты в неотложной хирургической гастроэнтерологии.
                            М., 2009. 173 с.
                            <br>8. Kahrilas P.J., Shaheen N.J., Vaezi M.F. American Gastroenterological Association
                            Institute; Clinical Practice and Quality Management Committee American Gastroenterological
                            Association Institute technical review on the management of gastroesophageal reflux disease
                            // Gastroenterology. 2008. Vol. 135 (4). Р. 1392–1413.
                            <br>9. Лапина Т.Л. Лечение эрозивно-язвенных поражений желудка и двенадцатиперстной кишки //
                            РМЖ. 2001. Т. 9. № 13–14. С. 602–607.
                            <br>10. Минушкин О.Н. Сложные вопросы терапии ингибиторами протонной помпы // Лечащий врач.
                            2007. № 6.
                            <br>11. Hawkey C., Karrasch J., Szczepanski L. et al. Omeprazole compared with misoprostol
                            for ulcers associated with nonsteroidal anti-inflamatory drugs // New Engl. J. Med. 1998.
                            Vol. 338. P. 727–734.
                            <br>12. Katelaris P., Phelps G. for MURO Study Group. A randomised controlled comparison of
                            omeprazole capsules and multiple unit pellet system tablets for healling ulcerative
                            oesophagitis // Aust. Gastroenterol. Week. 1999. P. A219.
                            <br>13. Cotoraci С., De Muynck С., Huber R. et al. Bioequvalence between omeprazole 20 mg
                            MUPS and its incapculated form // Gut. 2000. Vol. 47.Suppl. 3. P. 34.
                            <br>14. Geus W., Mathot R., Mulder P., Lamers C. Pharmacodinamics and kinetics of omeprazole
                            MUPS 20 mg and pantoprazole 40 mg during repeated oral administration in Helicobacter
                            pylori-negative subjects // Aliment Pharmacol. Ther. 2000. Vol. 14. N 8. P. 1057–1064.
                            <br>15. Malfertheiner P., Megrand F., O’Morain C. et al. Current concepts in the management
                            of H.P. infection. -The Maastricht 2-2000 Consensus Report // Aliment Pharmacol Ther. 2002.
                            Vol. 16. Р. 167–180.
                            <br>16. Ивашкин В.Т., Мегро Ф., Лапина Т.Л. Helicobacter pylori: революция в
                            гастроэнтерологии. М., 1999.
                            <br>17. Исаков В.А., Домогарский И.В. Хеликобактериоз. М., 2003. С. 411.
                            <br>18. Ma B., Hang L., Chen G., Du Y. // West Indian Med J. 2013 Feb. Vol. 62 (2). Р.
                            135–139.
                            <br>19. Nagahara A., Suzuki T., Nagata N., Sugai N., Takeuchi Y., Sakurai K., Miyamoto M.,
                            Inoue K., Akiyama J., Mabe K., Konuma I., Kamada T., Haruma K. A multicentre randomised
                            trial to compare the efficacy of omeprazole versus rabeprazole in early symptom relief in
                            patients with reflux esophagitis // J Gastroenterol. 2013.
                            <br>20. Сереброва С.Ю. Омепразол или пантопразол: острые моменты дискуссии // Лечащий врач.
                            2013. № 2.
                            <br>21. Стасева И.В. Сравнительная эффективность ингибиторов протонной помпы в лечении
                            гастропатии, индуцированной приемом нестероидных противовоспалительных препаратов: Дис. …
                            канд. мед. наук. М., 2005.
                            <br>22. Маев И.В., Андреев Д.Н., Гончаренко А.Ю., Дичева Д.Т. Ингибиторы протонной помпы как
                            основа лечения кислотозависимых заболеваний // Справочник поликлинического врача. 2013. №
                            7–8. С. 12–14.
                            <br>23. Брискин Б.С., Гарсия Х.С. Возможности использования ингибитора протонной помпы
                            омепразола (лосек) для лечения кровоточащих дуоденальных язв // Фарматека. 2005. № 4–5
                            (100).
                            <br>24. Щербаков П.Л. Гастроэзофагеальная рефлюксная болезнь у детей // Болезни органов
                            пищеварения. 2007. Т. 9. № 2. С. 42–47.
                            <br>25. Лапина Т.Л. Лечение эрозивно-язвенных поражений желудка и двенадцатиперстной кишки
                            // РМЖ. 2001. Т. 9. № 13–14. С. 602–607.
                            <br>26. Курилович С.А., Черношейкина Л.Е. Антисекреторный потенциал пантопразола (Санпраза)
                            // Экспериментальная и клиническая гастроэнтерология. 2008. № 7. С. 119–122.</p>
                        <p style="font-style: italic">Оригинальная статья опубликована на сайте РМЖ (Русский медицинский
                            журнал):
                            https://www.rmj.ru/articles/gastroenterologiya/Ingibitory_protonnoy_pompy_v_terapii_kislotozavisimyh_zabolevaniy/#ixzz5QHCCehrn</p>
                    </div>
                </div>
<!--                <a @click="animateScroll" class="more-detail">-->
<!--                    Оставить комментарий → </a>-->
<!--                <br>-->
<!--                <p style="font-size: 11px; color: #909090;">-->
<!--                    <a style="color: #909090; text-decoration: underline"-->
<!--                       href="http://5-clinic.com/category/гастроэнтерология/">Гастроэнтерология</a>,-->
<!--                    <a style="color: #909090; text-decoration: underline"-->
<!--                       href="http://5-clinic.com/category/научная-статья/">Научная статья</a></p>-->
<!--                <div class="divider"></div>-->
<!--                <comment-form id="comment-form" slug="" class="comment-wrapper"/>-->
            </div>

        </div>
    </div>
</template>

<script>
import ContentHeader from "../../components/layout/ContentHeader";
import CommentForm from "@/components/CommentForm";
import animateScrollTo from "animated-scroll-to";

export default {
    name: "research2",
    components: {
        ContentHeader,
        CommentForm
    },
    methods: {
        animateScroll() {
            animateScrollTo(document.getElementById("comment-form"))
        }
    }
}

</script>

<style lang="scss" scoped>
.container {
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 13px;
}

strong {
    color: rgb(0, 0, 0);
    font-weight: 700;
    padding: 0;
}

p {
    padding: 1em 0;
    color: #666;
    line-height: 150%;
}

.bold {
    font-weight: bold;
}

.left-1em {
    margin-left: 1em;
}

h3 {
    font-size: 18px;
    margin: 0;
    padding: 0;
    font-weight: normal;
    color: #000;
}

h3:after {
    content: "";
    display: block;
    bottom: 0;
    width: 50px;
    height: 2px;
    background: #00b6cc;
    margin-top: 10px
}

.inv-divider {
    height: 32px;
    display: block;
    width: 100%;
}

.divider {
    height: 1px;
    border-top: 1px solid #ebebeb;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
    margin: 20px 0;
}

.flex {
    display: flex;
}

.flex.center {
    align-items: center;
}

.box {
    display: flex;
    width: 380px;
    margin-left: 30px;
}

.box:first-child {
    margin: 0;
}

.link {
    color: #006688;
    border-bottom: 1px dotted #006688;
    text-decoration: none;
    display: block;
    width: fit-content;
    height: fit-content;
}

.left-30px {
    margin-left: 30px;
}

.article-detail {
    display: flex;
    margin-top: 30px;

    @media screen and (max-width: 570px) {
        flex-direction: column;
        align-items: flex-start;
    }

    .comment_box {
        width: 100px;
        display: flex;
        align-items: center;
        margin-bottom: 25px;
        flex-direction: column;

        @media screen and(max-width: 570px) {
            flex-direction: row;
            width: 250px;

            .date {
                margin-right: 10px;
            }

            .value, .comments_number {
                margin-top: 0;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        .date {
            width: 100%;
            position: relative;
        }

        .date .value {
            background-color: #006688;
            color: #fff;
            padding: 10px 13px;
            font-size: 12px;
            width: 100%;

            @media screen and (max-width: 768px) {
                padding: 10px 10px;
            }
        }

        .arrow_date {
            content: '';
            top: 0;
            right: -4px;
            display: inline;
            border-color: #006688 transparent;
            visibility: visible;
            position: absolute;
            border-style: solid;
            border-width: 5px 5px 0 0;

            @media screen and(max-width: 570px) {
                top: unset;
                right: unset;
                left: 0;
                bottom: -4px;
            }
        }
    }


    &__content {
        margin-left: 20px;
        border-bottom: 1px solid #E0E0E0;

        .article-detail-top {
            cursor: pointer;
        }

        @media screen and (max-width: 570px) {
            margin-left: 0;
        }
        @media screen and (max-width: 768px) {
            width: 100%;
        }
    }

    &__title {
        text-align: left;
        margin-bottom: 10px;

    }

    @media screen and (max-width: 450px) {

        &__title {
            h2 {
                font-size: 18px;
            }

        }
    }

    &__image {
        @media screen and (max-width: 768px) {
            width: 100%;
        }
    }

    &__desc {
        text-align: left;

        p {
            text-align: left;
            font-size: 14px;
        }

        .more-detail {
            font-size: 14px;
            margin: 15px 0;
        }

        .routes {
            margin: 15px 0;
        }

        p {
            padding-bottom: 1em;
        }
    }
}

.comment-container {
    position: relative;

    .comments_number {
        position: absolute;
        left: -100px;
        width: 85px;

        @media screen and (max-width: 570px) {
            position: unset;
        }
    }
}

.comments_number {
    width: 100%;
    margin-top: 4px;
    background-color: #00b6cc;
    padding: 6px 10px;
    color: #fff;
    font-size: 11px;
}

.comment-item {
    display: flex;
    padding: 30px 0;

}

.comment-item:not(:last-child) {
    border-bottom: 1px solid #E0E0E0;
}

.posted_by {
    font-size: 11px;
    color: #909090;
}

.comment-item p {
    color: #666;
    line-height: 150%;
    font-size: 12px;
    padding: 15px 0;
}

.comment_details {
    text-align: left;
    padding-left: 30px;
}

</style>
